import {
  DocumentTitle,
  MinWidth,
  useCurrentUser,
  useMediaQuery,
} from "@indietabletop/appkit";
import { HereComeTheBastardsBanner } from "../NewsBanner/NewsBanner.tsx";
import {
  HeaderSidenavDisclosure,
  HeaderTitle,
  PageContainer,
  PageHeader,
  PageMain,
} from "../Page/Page.tsx";
import { DashboardLink } from "./DashboardLink.tsx";
import { Footer } from "./Footer.tsx";
import { JoinPrompt } from "./JoinPrompt.tsx";
import { navLinks, NavLinkUsage } from "./navLinks.ts";
import { page } from "./style.css.ts";

export function DashboardPage() {
  const currentUser = useCurrentUser();
  const isMediumOrWider = useMediaQuery(MinWidth.MEDIUM);
  const isWideOrWider = useMediaQuery(MinWidth.WIDE);

  return (
    <>
      <DocumentTitle>Dashboard</DocumentTitle>

      <PageContainer className={page.container}>
        {isMediumOrWider ? (
          <PageHeader>
            <div />
            <HeaderTitle>Dashboard</HeaderTitle>
          </PageHeader>
        ) : (
          <PageHeader>
            <HeaderSidenavDisclosure />
            <HeaderTitle>Space Gits</HeaderTitle>
          </PageHeader>
        )}

        <PageMain>
          <HereComeTheBastardsBanner variant="dashboard" />

          <div className={page.links}>
            {navLinks
              .filter((link) => {
                // Only render links that should be used on the Dashboard.
                if (!(link.usage & NavLinkUsage.DASHBOARD)) {
                  return false;
                }

                // On wide-or-wider viewports, only render the card-style
                // dashboard links (which must have an imageSrc).
                if (isWideOrWider) {
                  return (
                    !!(link.usage & NavLinkUsage.DASHBOARD_CARDS) &&
                    !!link.imageSrc
                  );
                }

                return true;
              })
              .map((link) => {
                return <DashboardLink key={link.href} {...link} />;
              })}
          </div>

          {!currentUser && <JoinPrompt />}
        </PageMain>
      </PageContainer>

      <Footer />
    </>
  );
}
